<div [formGroup]="form" class="p-d-flex p-flex-column p-fluid">
  <div class="p-d-flex p-flex-column p-flex-md-row p-mr-4 p-fluid gap-8">
    <div class="flex-1">
      <kodit-field fieldLabel="Broj obaveštenja" fieldLabelFor="searchTerm">
        <kodit-text-input
          class="show"
          [formCtrl]="form.controls.searchTerm"
          formCtrlId="searchTerm"
          placeholder="Broj obaveštenja ili broj dokumenta..."
        ></kodit-text-input>
      </kodit-field>
    </div>
    <div class="flex-1">
      <kodit-field fieldLabel="Naziv davaoca" fieldLabelFor="stranke">
        <kodit-stranka-filter-multiselect
          [strankeFormArray]="strankeFormArray"
          ctrlId="stranke"
        ></kodit-stranka-filter-multiselect>
      </kodit-field>
    </div>
  </div>
  <div class="p-d-flex p-flex-column p-flex-md-row p-mr-4 gap-8">
    <div class="flex-1">
      <kodit-field fieldLabel="Datum od" fieldLabelFor="dateFrom">
        <kodit-calendar
          [formCtrl]="form.controls.dateFrom!"
          formCtrlId="dateFrom"
        ></kodit-calendar>
      </kodit-field>
    </div>
    <div class="flex-1">
      <kodit-field fieldLabel="Datum do" fieldLabelFor="dateTo">
        <kodit-calendar
          [formCtrl]="form.controls.dateTo!"
          formCtrlId="dateTo"
        ></kodit-calendar>
      </kodit-field>
    </div>
  </div>
</div>
